/* ====================================================================
   RECENTLY VIEWED — rendered as a BENTO, not a carousel.

   Aurora's own `recently-viewed` section is a carousel built on
   `product-card`, a completely different component from the homepage
   tiles. Chasing it with CSS never made the two match, so this renders
   the SAME `.pp-pb__*` markup the Liquid emits and therefore inherits
   assets/pp-prodbento.css outright — identical by construction.

   ⚠ The class names below must stay in step with the markup in
   sections/pp-prodbento.liquid. That duplication is the price of the
   guarantee; changing one without the other silently splits them again.

   Source: `PicturePartyTheme-RecentlyViewed` in localStorage — an array of
   product HANDLES (verified on the live store).
   ==================================================================== */
(function () {
  var KEY = 'PicturePartyTheme-RecentlyViewed';

  function money(cents) {
    var v = cents / 100;
    /* match Liquid's money_without_trailing_zeros */
    return '$' + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2));
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function card(p, span) {
    var img = p.featured_image
      ? '<img class="pp-pb__img" src="' + esc(p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '$1?width=1000')) +
        '" alt="' + esc(p.title) + '" width="1000" height="1000" loading="lazy">'
      : '';
    var badge = (p.variants && p.variants.length > 1)
      ? '<span class="pp-pb__badge">' + p.variants.length + ' options</span>' : '';
    /* data-type carries the plate tint, same as the liquid path. `type` is on
       the product JSON from /products/<handle>.js; handleize it here so the
       CSS selectors match the ones the liquid emits. */
    var ty = String(p.type || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    return '<a class="pp-pb__cell pp-pb__cell--' + span + '" data-type="' + esc(ty) + '" href="' + esc(p.url) + '">' +
             '<span class="pp-pb__media">' + img + badge + '</span>' +
             '<span class="pp-pb__label">' +
               '<span class="pp-pb__title">' + esc(p.title) + '</span>' +
               '<span class="pp-pb__price">from ' + money(p.price) + '</span>' +
             '</span>' +
           '</a>';
  }

  function fill(grid) {
    var handles;
    try { handles = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { handles = []; }
    if (!Array.isArray(handles) || !handles.length) return hide(grid);

    /* Don't show the product you are already looking at. */
    var here = (location.pathname.match(/\/products\/([^/?#]+)/) || [])[1];
    handles = handles.filter(function (h) { return h && h !== here; });

    var limit = parseInt(grid.getAttribute('data-pp-limit'), 10) || 8;
    var spans = (grid.getAttribute('data-pp-spans') || '').split(',').map(function (s) { return s.trim(); });
    handles = handles.slice(0, limit);
    if (!handles.length) return hide(grid);

    Promise.all(handles.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (list) {
      var ok = list.filter(Boolean);
      /* ⚠ A handle can 404 (product unpublished or renamed). Assign spans
         AFTER filtering, or the tiling gets a hole where the dead one was. */
      if (!ok.length) return hide(grid);
      grid.innerHTML = ok.map(function (p, i) { return card(p, spans[i] || 'quarter'); }).join('');
    }).catch(function () { hide(grid); });
  }

  function hide(grid) {
    var sec = grid.closest('.pp-pb');
    if (sec) sec.style.display = 'none';
  }

  function init() {
    document.querySelectorAll('.pp-pb__grid[data-pp-source="recent"]').forEach(fill);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
